// tslint:disable: max-line-length
import { Component, OnInit, Inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { RouterOutlet, Router, NavigationStart } from '@angular/router';
import { Event as NavigationEvent } from '@angular/router';
import { Loader } from '@googlemaps/js-api-loader';
import { filter } from 'rxjs/operators';
import { Environment } from 'src/environments/environment';
import { NavigationHistoryService } from './services/navigation-history.service';
import { ENV } from 'src/environment.provider';
import { registerLocaleData } from '@angular/common';
import localeLa from '@angular/common/locales/en-GB';
import appVersionFile from '../assets/app-version.json';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css'],
	imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
	constructor(
		private readonly matIconRegistry: MatIconRegistry,
		private readonly domSanitizer: DomSanitizer,
		private readonly router: Router,
		private readonly navigationHistory: NavigationHistoryService,
		@Inject(ENV) private env: Environment
	) {
		this.matIconRegistry
			.addSvgIcon(
				`sl-alert`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-alert.svg`
				)
			)
			.addSvgIcon(
				`sl-nav-chart`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-chart.svg`
				)
			)
			.addSvgIcon(
				`sl-nav-home`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-home.svg`
				)
			)
			.addSvgIcon(
				`sl-nav-location`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-location.svg`
				)
			)
			.addSvgIcon(
				`sl-nav-password`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-password.svg`
				)
			)
			.addSvgIcon(
				`sl-nav-profile`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-profile.svg`
				)
			)
			.addSvgIcon(
				`sl-nav-setting`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-setting.svg`
				)
			)
			.addSvgIcon(
				`sl-nav-work`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-work.svg`
				)
			)
			.addSvgIcon(
				`sl-nav-work-17`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-work-17.svg`
				)
			)
			.addSvgIcon(
				`sl-nav-calendar`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-calendar.svg`
				)
			)
			.addSvgIcon(
				`sl-nav-billing`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-billing.svg`
				)
			)
			.addSvgIcon(
				`sl-nav-learning`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-learning.svg`
				)
			)
			.addSvgIcon(
				`sl-nav-client`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-client.svg`
				)
			)
			.addSvgIcon(
				`sl-filter`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-filter.svg`
				)
			)
			.addSvgIcon(
				`sl-down-caret`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-down-caret.svg`
				)
			)
			.addSvgIcon(
				`sl-up-caret`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-up-caret.svg`
				)
			)
			.addSvgIcon(
				`sl-add`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-add.svg`
				)
			)
			.addSvgIcon(
				`sl-add-user`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-add-user.svg`
				)
			)
			.addSvgIcon(
				`sl-add-user-21`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-add-user-21.svg`
				)
			)
			.addSvgIcon(
				`sl-lock`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-lock.svg`
				)
			)
			.addSvgIcon(
				`sl-device-group-inherited`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-device-group-inherited.svg`
				)
			)
			.addSvgIcon(
				`sl-device-group-owned`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-device-group-owned.svg`
				)
			)
			.addSvgIcon(
				`sl-open-key-door`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-open-key-door.svg`
				)
			)
			.addSvgIcon(
				`sl-remove-device`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-remove-device.svg`
				)
			)
			.addSvgIcon(
				`sl-release-hasp`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-release-hasp.svg`
				)
			)
			.addSvgIcon(
				`sl-install-device`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-install-device.svg`
				)
			)
			.addSvgIcon(
				`sl-update-firmware`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-update-firmware.svg`
				)
			)
			.addSvgIcon(
				`sl-image`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-image.svg`
				)
			)
			.addSvgIcon(
				`sl-info-square`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-info-square.svg`
				)
			)
			.addSvgIcon(
				`sl-edit`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-edit.svg`
				)
			)
			.addSvgIcon(
				`sl-left-caret`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-left-caret.svg`
				)
			)
			.addSvgIcon(
				`sl-right-caret`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-right-caret.svg`
				)
			)
			.addSvgIcon(
				`sl-spinner`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-spinner.svg`
				)
			)
			.addSvgIcon(
				`sl-download`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-download.svg`
				)
			)
			.addSvgIcon(
				`sl-map-pin`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-map-pin.svg`
				)
			)
			.addSvgIcon(
				`sl-hamburger-menu`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-hamburger-menu.svg`
				)
			)
			.addSvgIcon(
				`sl-missing-key`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-missing-key.svg`
				)
			)
			.addSvgIcon(
				`sl-low-battery`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-low-battery.svg`
				)
			)
			.addSvgIcon(
				`sl-key-not-detected`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-key-not-detected.svg`
				)
			)
			.addSvgIcon(
				`sl-document`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-document.svg`
				)
			)
			.addSvgIcon(
				`sl-dismiss`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-dismiss-note.svg`
				)
			)
			.addSvgIcon(
				`sl-access-code-gen`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-access-code.svg`
				)
			)
			.addSvgIcon(
				`sl-access-code-gen-filled`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-access-code-filled.svg`
				)
			)
			.addSvgIcon(
				`sl-hasp-code-gen`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-hasp-code.svg`
				)
			)
			.addSvgIcon(
				`sl-hasp-code-gen-filled`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-hasp-code-filled.svg`
				)
			)
			.addSvgIcon(
				`sl-generate-access-code`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-generate-access-code.svg`
				)
			)
			.addSvgIcon(
				`sl-generate-hasp-code`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-generate-hasp-code.svg`
				)
			)
			.addSvgIcon(
				`sl-danger-triangle`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-danger-triangle.svg`
				)
			)
			.addSvgIcon(
				`sl-trash`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-trash.svg`
				)
			)
			.addSvgIcon(
				`sl-check`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-check.svg`
				)
			)
			.addSvgIcon(
				`sl-danger-circle`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-danger-circle.svg`
				)
			)
			.addSvgIcon(
				'sl-three-users-active',
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-three-users-active.svg`
				)
			)
			.addSvgIcon(
				`sl-hamburger-menu-active`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-hamburger-menu-active.svg`
				)
			)
			.addSvgIcon(
				'sl-three-users-inactive',
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-three-users-inactive.svg`
				)
			)
			.addSvgIcon(
				`sl-hamburger-menu-inactive`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-hamburger-menu-inactive.svg`
				)
			)
			.addSvgIcon(
				`sl-senturian-lock`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-senturian-lock.svg`
				)
			)
			.addSvgIcon(
				`sl-bell-crossed-out`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-bell-crossed-out.svg`
				)
			)
			.addSvgIcon(
				`sl-shield-checkmark`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-shield-checkmark.svg`
				)
			)
			.addSvgIcon(
				`sl-shield-checkmark-red`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-shield-checkmark-red.svg`
				)
			)
			.addSvgIcon(
				`sl-shield-with-x`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-shield-with-x.svg`
				)
			)
			.addSvgIcon(
				`sl-bell-crossed-out-orange`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-bell-crossed-out-orange.svg`
				)
			)
			.addSvgIcon(
				`sl-settings`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-settings.svg`
				)
			)
			.addSvgIcon(
				`sl-search`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-search.svg`
				)
			)
			.addSvgIcon(
				`sl-calendar-date`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-calendar-date.svg`
				)
			)
			.addSvgIcon(
				`sl-info-circle`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-info-circle.svg`
				)
			)
			.addSvgIcon(
				`sl-alert-circle`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-alert-circle.svg`
				)
			)
			.addSvgIcon(
				`sl-polygon`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-polygon.svg`
				)
			)
			.addSvgIcon(
				`sl-description`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-description.svg`
				)
			)
			.addSvgIcon(
				`sl-add-property`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-add-property.svg`
				)
			)
			.addSvgIcon(
				`sl-select-existing-property`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-select-existing-property.svg`
				)
			)
			.addSvgIcon(
				`sl-upload-item`,
				domSanitizer.bypassSecurityTrustResourceUrl(
					`${env.deployPath}/../assets/icons/icon-upload-item.svg`
				)
			);
		router.events
			.pipe(
				filter((event: NavigationEvent) => {
					return event instanceof NavigationStart;
				})
			)
			.subscribe((route: any) => {
				if (route instanceof NavigationStart) {
					route = route as NavigationStart;
					navigationHistory.addRoute(route);
				}
			});

		// I don't really like having to do this but it's the only way I could get Durka (which is using Latin as its
		// language setting in Phrase) to work without breaking the other languages. Latain doesn't doesn't have locale
		// settings for things like date and currency formatting so every time we used a date pipe it was throwing
		// and error because of not being locale settings. This and the import above sets Latain to use the same locale
		// settings en-GB and leaves all the other languages to use their own locale settings.
		registerLocaleData(localeLa, 'la');
	}

	ngOnInit(): void {
		// Add the app version to the body tag for debugging purposes :
		document.body.dataset['appVersion'] = appVersionFile.version;

		if (this.env.isTesting) {
			return;
		}

		const loader = new Loader({
			apiKey: this.env.mapAPIKey,
			version: 'weekly',
		});

		loader.load().then(() => {});
	}
}
